import { merge } from '../../../helper';
import exLanguage from '../../../language';

import getFieldCount from './getFieldCount';
import { count } from '../rows/count';

// ----------------------------------------------------------------------------

function createTableEmpty(element: HTMLElement, config?: Record<string, any>): HTMLElement {
    const defConfig: Record<string, any> = {
        html: exLanguage.line('table.empty'),
    };

    merge(defConfig, config);

    const fieldCount = getFieldCount(element);
    const rowCount = count(element, {
        rowCount: 1,
        columnCount: 1,
    });

    const elColumn = rowCount[0].columns[0];
    elColumn.addClass('table-empty');
    elColumn.setAttribute('colspan', String(Math.max(fieldCount, 1)));
    elColumn.innerHTML = defConfig.html;

    return rowCount[0].row;
}

// ----------------------------------------------------------------------------

export default createTableEmpty;
